export const version = '3.2.2'
export const name = 'js-libp2p'
